import { apiClient } from "lib/apiClient";
import { ICoordinate, IDriveTimeGeometry } from "features/MarketAreas/types";

export interface IGenerateDriveTimeAreaPayload {
  center: ICoordinate;
  driveTimeMinutes: number;
}

export const generateDriveTimeArea = async (
  payload: IGenerateDriveTimeAreaPayload,
  signal?: AbortSignal
): Promise<IDriveTimeGeometry> => {
  const response = await apiClient.post<IDriveTimeGeometry>(
    "/market-areas/helper/coordinates/drive-time/preview",
    payload,
    { signal }
  );

  return response.data;
};
